import {TimeSince} from '~/ViewInvitation/common/TimeSince';

export const LastViewedCopy = (props) => {
  const {viewDate, showViewDate} = props;

  const getLastViewedCopy = () => {
    let status;
    if (showViewDate) {
      if (viewDate) {
        const trimmedDate = viewDate.slice(0, -5);
        status = (
          <>
            Viewed <TimeSince timestamp={trimmedDate} />
          </>
        );
      } else {
        status = 'Not yet viewed';
      }
      return status;
    }
    return 'Not yet replied';
  };

  return <div className="view-invitation__last-viewed-copy">{getLastViewedCopy()}</div>;
};
